import React from 'react';
import { useTranslation } from 'react-i18next';
import Schwager from '../assets/logo-schwager.png';
import Bago from '../assets/logo-bago.png';
import Mapsa from '../assets/logo-larrain.png';
import Ese from '../assets/ese.png';
import Life4 from '../assets/life4logo.png';
import Gruas from '../assets/logo-gruas5.png';

const Clients = () => {
  const { t } = useTranslation();

  const logos = [
    { src: Schwager, alt: 'Logo de Schwager, cliente de Eticpro' },
    { src: Bago, alt: 'Logo de Laboratorio Bagó, cliente de Eticpro' },
    { src: Mapsa, alt: 'Logo de Larrain, cliente de Eticpro' },
    { src: Life4, alt: 'Logo de Life4, cliente de Eticpro' },
    { src: Gruas, alt: 'Logo de Grúas San Blas, cliente de Eticpro' },
    { src: Ese, alt: 'Logo de ESE Business School' },
  ];

  return (
    <section id="clients" className="w-full bg-white py-16 px-4" aria-labelledby="clients-heading">
      <div className="max-w-[1100px] mx-auto text-center">
        <h2 id="clients-heading" className="md:text-4xl sm:text-3xl text-2xl font-bold py-2 text-slate-900">
          {t('clients.title')}
        </h2>
        <p className="text-slate-500 mb-10">{t('clients.subtitle')}</p>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {logos.map((logo) => (
            <div key={logo.alt} className="flex items-center justify-center grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition duration-300">
              <img
                className="h-10 md:h-14 w-auto object-contain"
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                decoding="async"
                style={{ maxWidth: '140px' }}
              />
            </div>
          ))}
        </div>


      </div>
    </section>
  );
};

export default Clients;
